import { render, staticRenderFns } from "./fxtb.vue?vue&type=template&id=5d80ec1b&scoped=true"
import script from "./fxtb.vue?vue&type=script&lang=js"
export * from "./fxtb.vue?vue&type=script&lang=js"
import style0 from "./fxtb.vue?vue&type=style&index=0&id=5d80ec1b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80ec1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d80ec1b')) {
      api.createRecord('5d80ec1b', component.options)
    } else {
      api.reload('5d80ec1b', component.options)
    }
    module.hot.accept("./fxtb.vue?vue&type=template&id=5d80ec1b&scoped=true", function () {
      api.rerender('5d80ec1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkequipmentmanagement/components/fxtb.vue"
export default component.exports